module.exports = __webpack_public_path__ + "static/img/down-corner-ramp-8m-x-2m_256.18910ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-ramp-8m-x-2m_256.png
// module id = Avj8
// module chunks = 0